<template>
  <div class="right-tip-word overflow-y-auto overflow-x-hidden py-4 pr-4 bg-white box-border mr-4">
    <h4>计算示例</h4>
    <p class="text-indent-1">指标：城镇用户平均可支配年收入</p>
    <p>数据源：该指标关联的数据源如下</p>
    <table class="ml-4" border="1" Cellspacing="0" Cellpadding="0">
      <tr>
        <td>用户</td>
        <td>地区</td>
        <td>可支配年收入（元）</td>
      </tr>
      <tr>
        <td>张三</td>
        <td>城镇</td>
        <td>10000</td>
      </tr>
      <tr>
        <td>李四</td>
        <td>农村</td>
        <td>8000</td>
      </tr>
      <tr>
        <td>王五</td>
        <td>城镇</td>
        <td>13000</td>
      </tr>
      <tr>
        <td>赵六</td>
        <td>农村</td>
        <td>14000</td>
      </tr>
      <tr>
        <td>孙七</td>
        <td>城镇</td>
        <td>10000</td>
      </tr>
    </table>
    <p>数据范围:“地区 = 城镇” 的所有用户</p>
    <p>计算公式:“地区 = 城镇” 的所有用户的</p>
    <p class="text-indent-4">可支配年收入的平均值。</p>
    <p>即(10000+13000+10000)/3=11000</p>
  </div>
</template>

<script>
export default {
  name: 'CellRightTip',
  components: {
  },
  data() {
    return {
      
    }
  },
}
</script>

<style lang="scss">
.text-indent-1{
  text-indent: 1rem;
}
.text-indent-4{
  text-indent: 4rem;
}
.text-indent-2{
  text-indent: 2rem;
}
</style>
<style lang="scss" scoped>
.right-tip-word{
  height: fit-content;
  ol li {
    font-size: 14px;
    line-height: 24px;
  }
  ol li::before{
    content: "\2022  ";
    font-size: 22px;
    color: rgba(0,0,0,0.15);
    margin-left: -16px;
  }
}
td {
  border: 1px solid #e7e9eb;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  width: 129px;
  height: 32px;
  background-color: #fff;
  text-align: center;
}
table tr:nth-child(1) td{
  background-color: #f5f5f5;
}
table tr td:nth-child(1),table tr td:nth-child(2){
  width: 75px;
}
table tr td:nth-child(3){
  width: 198px;
}
</style>
